import React from "react";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";
import logofoict from '../assets/images/logofoict.png'
const Footer = () => {
  return (
    <footer className="bg-white text-[#0f172a] px-6 md:px-20 py-12 border-t">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-16">

        {/* Column 1 - Logo & Contact */}

        <div className="flex flex-col text-left min-w-0">
          <img
            src={logofoict}
            alt="FOICT Logo"
            className="w-60 h-auto object-contain"
          />
          <p className="text-sm text-gray-600 font-medium leading-snug pt-5">
            FOICT – Finding Opportunities In Changing Times. Empowering individuals through skill-based learning, digital innovation, and career transformation.
          </p>
        </div>

        {/* Column 2 - Navigation */}
        <div className="flex flex-col text-left min-w-0">
          <h3 className="font-semibold mb-4 text-[#fc3c04] text-lg">Quick Link</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li><Link to="/" className="hover:text-[#345bf3]">Home</Link></li>
            <li><Link to="/job" className="hover:text-[#345bf3]">Jobs</Link></li>
            <li><Link to="/courses" className="hover:text-[#345bf3]">Courses</Link></li>
            <li><Link to="/blogs" className="hover:text-[#345bf3]">Blogs</Link></li>

          </ul>
        </div>

        {/* Column 3 - Information */}
        <div className="flex flex-col text-left min-w-0">
          <h3 className="font-semibold mb-4 text-[#fc3c04] text-lg">Information</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            <li><Link to="/about" className="hover:text-[#345bf3]">About</Link></li>

            <li><Link to="/contact" className="hover:text-[#345bf3]">Contact</Link></li>
            <li><Link to="/terms" className="hover:text-[#345bf3]">Terms & Conditions</Link></li>
            <li><Link to="/login" className="hover:text-[#345bf3]">Login </Link></li>
          </ul>
        </div>



        <div className="flex flex-col text-left min-w-0">
          <h2 className="text-2xl font-bold mb-5 text-[#fc3c04]">Foict</h2>
          <div className="space-y-2 text-sm text-gray-700">
            <p><span className="mr-2">📍</span>Jabalpur (MP)</p>
            <p>
              <span className="mr-2">✉️</span>
              <a href="mailto:subhash@foict.com" className="text-[#345bf3] hover:underline">
                subhash@foict.com
              </a>
            </p>
            <p>
              <span className="mr-2">📞</span>
              <a href="tel:9820567389" className="text-[#345bf3] hover:underline">
                9820567389
              </a>
            </p>
          </div>
          <div className="flex space-x-4 mt-6 text-xl text-[#fc3c04]">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          </div>
        </div>
      </div>

      {/* Bottom Text */}
      <div className="text-sm text-center mt-12 text-gray-500">
        © 2025 Foict. All rights reserved. | Designed by{" "}
        <a
          href="https://yashsoftsolution.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#fc3c04] hover:text-[#345bf3]"
        >
          Yashsoft Solution
        </a>
      </div>
    </footer>
  );
};

export default Footer;
